import { Filters } from '../GamesBlock/hooks/types'
import { GameWithUserInformation } from '../GamesBlock/types'

export function getGamesForSmartCategory(games: GameWithUserInformation[]) {
  return games?.map(({ slug }) => ({ slug })) || []
}

export const filters: Filters = [
  {
    compareFn: ({ isFavorite, hasFreeRounds, isUnfinished }) => isFavorite || hasFreeRounds || isUnfinished,
  },
]
